import client from 'utils/client';

const CustomisationMiddleware = store => next => action => {
  if (action.type === 'POST_CUSTOMIZATION') {
    store.dispatch({
      type: 'GET_REVIEW_RESPONSE',
      response: 'fetching'
    });
    const postArr = { products: [] };

    const postcustomizationItems = store.getState().customizationItems;
    const postCustomizationToggleItems =
      store.getState().costumizationToggleItems;

    action.customizations.map(productGroups =>
      productGroups.products.map(products => {
        const product = {
          id: products.id,
          choices_id: products.choices_id,
          subgroup_id: productGroups.id,
          sizes: []
        };

        products.sizes.map(size => {
          const customizationItem = [];
          if (!product.sizes.find(s => s.id === size.id))
            product.sizes.push({ id: size.id, customizations: [] });

          postCustomizationToggleItems.products
            .filter(
              item =>
                item.groupID === productGroups.id &&
                item.choicesID === products.choices_id &&
                item.productID === products.id
            )
            .map(toggledProduct => {
              if (toggledProduct.sponsorLogo) {
                customizationItem.push({
                  type: 'sponsor_logo',
                  properties: {}
                });
              }
              if (toggledProduct.clubLogo) {
                customizationItem.push({
                  type: 'club_logo',
                  properties: {}
                });
              }
              return customizationItem;
            });

          if (
            postCustomizationToggleItems.unisport &&
            products.type === 'tshirt'
          ) {
            customizationItem.push({
              type: 'unisport_logo',
              properties: {}
            });
          }

          postcustomizationItems
            .filter(
              item =>
                item.index === size.order_by &&
                item.groupID === productGroups.id &&
                item.productID === products.id &&
                item.choicesID === products.choices_id
            )
            .map(foundItem => {
              Object.keys(foundItem.value).map(customizationType => {
                customizationItem.push({
                  type: customizationType,
                  properties: {
                    render_value: foundItem.value[customizationType]
                  }
                });
                return customizationItem;
              });
              return customizationItem;
            });
          product.sizes
            .find(s => s.id === size.id)
            .customizations.push(customizationItem);
          return customizationItem;
        });
        postArr.products.push(product);
        return postArr;
      })
    );

    client
      .post('/services/product_groups/select_customizations/', postArr)
      .then(() => {
        store.dispatch({
          type: 'POST_SUCCESS_SIZES'
        });
        store.dispatch({
          type: 'REQUEST_REVIEW'
        });
        store.dispatch({
          type: 'GET_REVIEW_RESPONSE',
          response: 'success'
        });
      })
      .catch(() => {
        store.dispatch({
          type: 'GET_REVIEW_RESPONSE',
          response: 'fail'
        });
      });
  }

  if (action.type === 'UPDATE_CUSTOMIZATIONS') {
    store.dispatch({
      type: 'COSTUMIZE_ITEM',
      value: action.value,
      index: action.index,
      productID: action.productID,
      groupID: action.groupID,
      choicesID: action.choicesID
    });
    store.dispatch({
      type: 'CALCULATE_CUSTOMIZATION_SELECTION',
      customizations: store.getState().customizations,
      customizationItems: store.getState().customizationItems,
      costumizationToggleItems: store.getState().costumizationToggleItems
    });
  }

  if (action.type === 'UPDATE_UNISPORT_LOGO_CUSTOMIZATION') {
    store.dispatch({
      type: 'TOGGLE_UNISPORT_LOGO',
      toggleItem: action.toggleItem
    });
    store.dispatch({
      type: 'CALCULATE_CUSTOMIZATION_SELECTION',
      customizations: store.getState().customizations,
      customizationItems: store.getState().customizationItems,
      costumizationToggleItems: store.getState().costumizationToggleItems
    });
  }

  if (action.type === 'UPDATE_CLUB_LOGO_CUSTOMIZATION') {
    store.dispatch({
      type: 'TOGGLE_CLUB_LOGO',
      toggleItem: action.toggleItem
    });
    store.dispatch({
      type: 'CALCULATE_CUSTOMIZATION_SELECTION',
      customizations: store.getState().customizations,
      customizationItems: store.getState().customizationItems,
      costumizationToggleItems: store.getState().costumizationToggleItems
    });
  }

  if (action.type === 'UPDATE_SPONSOR_LOGO_CUSTOMIZATION') {
    store.dispatch({
      type: 'TOGGLE_SPONSOR_LOGO',
      toggleItem: action.toggleItem
    });
    store.dispatch({
      type: 'CALCULATE_CUSTOMIZATION_SELECTION',
      customizations: store.getState().customizations,
      customizationItems: store.getState().customizationItems,
      costumizationToggleItems: store.getState().costumizationToggleItems
    });
  }

  next(action);
};

export default CustomisationMiddleware;
